import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import ChatModal from "./ChatModal";
import useIsDesktop from "../hook/UseIsDecktop";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { XCircleIcon } from "lucide-react";

function Index({ children, title }) {
  const isDesktop = useIsDesktop();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const toggleChat = () => setIsChatOpen((prev) => !prev);

  useEffect(() => {
    if (isDesktop) {
      setIsSidebarOpen(true); // always open on desktop
    } else {
      setIsSidebarOpen(false); // always closed on mobile
    }
  }, [isDesktop]);

  // console.log({ isChatOpen });

  return (
    <div className="bg-dry xl:h-screen flex-colo">
      <div className="flex w-full">
        {/* Sidebar with fixed width */}

        {isDesktop && isSidebarOpen && (
          <div className="hidden xl:flex transition-all duration-300 w-[100px]">
            <Sidebar isSidebarOpen={isSidebarOpen} />
          </div>
        )}

        {/* Mobile Sidebar */}
        {!isDesktop && isSidebarOpen && (
          <>
            <div
              className={`fixed top-0 left-0 h-full z-50 transform transition-transform duration-500 ease-in-out
    ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
    w-full sm:w-3/5 bg-zinc-900 shadow-lg`}
            >
              <Sidebar
                isSidebarOpen={true}
                forceDetail={true}
                toggleSidebar={toggleSidebar}
              />
            </div>

            {/* Overlay */}
            <div
              className={`fixed inset-0 bg-black/40 transition-opacity duration-500 ease-in-out 
    ${isSidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"} 
    z-40`}
              onClick={toggleSidebar}
            />
          </>
        )}

        {/* Main content area grows to fill remaining space */}
        <div className="flex-1 xl:h-screen overflow-y-scroll relative transition-all duration-300 scrollbar-thin">
          <Header
            title={title}
            toggleSidebar={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
            toggleChat={toggleChat} // ✅ Add this line
          />
          <div className="xs:px-8 px-2 pt-24">{children}</div>
        </div>
      </div>

      {/* Right Chat Modal */}
      {isChatOpen && (
        <div
          className={`fixed top-0 right-0 h-screen z-50 transform transition-transform duration-500 ease-in-out 
    ${isChatOpen ? "translate-x-0" : "translate-x-full"} 
    w-full md:w-[400px]  shadow-lg`}
        >
          <ChatModal onClose={toggleChat} />
        </div>
      )}
    </div>
  );
}

export default Index;
